const createOptionsArray = (options) => options.map(option => {return {
    text: option.text,
    key: option.key,
    value: option.key
  }}
);

const getKey = (obj) => obj ? obj['key'] : null;

const makeLegend = (steps, colors) => {
  return colors.map((color, colorIndex) => {
    if (!steps[colorIndex + 1]) return {color, text: `> ${steps[colorIndex]}`}
    return {color, text: `${steps[colorIndex]} - ${steps[colorIndex + 1]}`}
  })
};

const makeLegendMinMax = (colors, min, max) => {
  const numSteps = colors.length

  const d = (max-min)/numSteps;
  let domain = [min];
  for (let i = 1; i <= numSteps; i++) {
    domain.push(Math.round(min + (d*i)));
  }


  return colors.map((color, colorIndex) => {
    if (!domain[colorIndex + 1]) return {color, text: `> ${domain[colorIndex]}`}
    return {color, text: `${domain[colorIndex]} - ${domain[colorIndex + 1]}`}
  })
};

export {
  createOptionsArray,
  getKey,
  makeLegend,
  makeLegendMinMax
}